var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls045(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 63,
    viewBox: "0 0 77 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2411 33.4151C50.808 33.3401 57.3616 34.0196 63.7733 35.4403C73.3546 37.7802 74.7234 41.338 74.7234 43.2537C74.7234 45.1695 73.3546 48.7273 63.7733 51.0672C50.8873 53.7676 37.5812 53.7676 24.6952 51.0672C15.1139 48.7273 13.7451 45.1695 13.7451 43.2537C13.7451 41.338 15.1139 37.7802 24.6952 35.4403C31.1114 34.0189 37.6698 33.3394 44.2411 33.4151Z",
    fill: "#FDFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.06
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8721 34.0043C50.2543 33.9295 56.624 34.5861 62.8567 35.961C72.0957 38.2326 73.5192 41.6809 73.5192 43.5419C73.5192 45.4029 72.1504 48.8649 62.8567 51.1365C50.3303 53.7466 37.4002 53.7466 24.8739 51.1365C15.6349 48.8649 14.2251 45.4166 14.2251 43.5419C14.2251 41.6672 15.5938 38.2326 24.8739 35.961C31.1112 34.5861 37.4854 33.9296 43.8721 34.0043Z",
    fill: "#FAFBFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3659 34.5927C49.5688 34.517 55.7597 35.1552 61.8166 36.4947C70.7682 38.6842 72.1643 42.0367 72.1643 43.8429C72.1643 45.6492 70.7956 48.988 61.8166 51.1911C49.6292 53.7348 37.0478 53.7348 24.8604 51.1911C15.8952 48.988 14.499 45.6492 14.499 43.8429C14.499 42.0367 15.8678 38.6842 24.8604 36.4947C30.935 35.1502 37.1447 34.5119 43.3659 34.5927Z",
    fill: "#F8F9FD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.928 35.1811C48.9459 35.1132 54.9522 35.7283 60.8313 37.0147C69.5092 39.1494 70.8779 42.3788 70.8779 44.1303C70.8779 45.8818 69.5092 49.1249 60.8313 51.2459C49.0231 53.7105 36.8329 53.7105 25.0247 51.2459C16.3468 49.1249 14.9644 45.8955 14.9644 44.1303C14.9644 42.3651 16.3331 39.1494 25.0247 37.0147C30.9036 35.727 36.91 35.1119 42.928 35.1811Z",
    fill: "#F6F7FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5037 35.7695C48.3378 35.7002 54.1608 36.297 59.8594 37.5484C68.2636 39.6009 69.6187 42.7209 69.6187 44.3903C69.6187 46.0597 68.2499 49.2207 59.8594 51.2322C48.4105 53.604 36.5968 53.604 25.1479 51.2322C16.7437 49.1796 15.3887 46.046 15.3887 44.3903C15.3887 42.7345 16.7574 39.5599 25.1479 37.5484C30.8464 36.2958 36.6695 35.699 42.5037 35.7695Z",
    fill: "#F3F5FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0518 36.3442C47.7247 36.2735 53.3871 36.8519 58.9285 38.0684C67.0588 40.0525 68.3865 43.063 68.3865 44.7187C68.3865 46.3744 67.0178 49.3849 58.9285 51.369C47.841 53.6679 36.3995 53.6679 25.312 51.369C17.1817 49.3849 15.854 46.3744 15.854 44.7187C15.854 43.063 17.2227 40.0525 25.312 38.0684C30.8087 36.8623 36.4246 36.2839 42.0518 36.3442Z",
    fill: "#F1F3FB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6138 36.9326C47.08 36.8652 52.536 37.4254 57.8744 38.6021C65.731 40.5041 67.045 43.4188 67.045 45.0198C67.045 46.6208 65.6763 49.5218 57.8744 51.4375C47.1464 53.6449 36.0811 53.6449 25.3531 51.4375C17.4965 49.5218 16.1963 46.6208 16.1963 45.0198C16.1963 43.4188 17.565 40.5041 25.3531 38.6021C30.6916 37.4254 36.1475 36.8652 41.6138 36.9326Z",
    fill: "#EFF1FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1349 37.521C46.4207 37.4622 51.6963 37.9993 56.8617 39.122C64.4309 40.9693 65.7175 43.7608 65.7175 45.3071C65.7175 46.8534 64.4309 49.6585 56.8617 51.4922C46.477 53.6307 35.7653 53.6307 25.3806 51.4922C17.7978 49.6585 16.5249 46.8534 16.5249 45.3071C16.5249 43.7608 17.7978 40.9693 25.3806 39.122C30.5547 37.9955 35.8398 37.4584 41.1349 37.521Z",
    fill: "#ECEFFA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7381 38.1094C45.8401 38.0487 50.9325 38.5675 55.9175 39.6557C63.2129 41.4209 64.4722 44.1029 64.4722 45.6082C64.4722 47.1134 63.2129 49.7133 55.9175 51.5469C45.9075 53.6084 35.5823 53.6084 25.5723 51.5469C18.2769 49.7817 17.0039 47.0997 17.0039 45.6082C17.0039 44.1166 18.2769 41.4209 25.5723 39.6557C30.5525 38.5668 35.6405 38.048 40.7381 38.1094Z",
    fill: "#EAEDF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2999 38.6978C45.2173 38.6375 50.1258 39.1333 54.9318 40.1757C61.9535 41.8725 63.1443 44.4587 63.1443 45.8955C63.1443 47.3323 61.8987 49.9185 54.9318 51.6153C45.2814 53.5856 35.3322 53.5856 25.6817 51.6153C18.66 49.9185 17.4692 47.3323 17.4692 45.8955C17.4692 44.4587 18.7148 41.8725 25.6817 40.1757C30.4832 39.1339 35.387 38.6381 40.2999 38.6978Z",
    fill: "#E8EBF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8756 39.2862C44.6023 39.2135 49.3222 39.6726 53.9463 40.6546C60.6943 42.2693 61.9125 44.7598 61.9125 46.1282C61.9125 47.4965 60.6943 49.987 53.9463 51.6017C44.6572 53.499 35.0802 53.499 25.7911 51.6017C19.0432 49.9733 17.825 47.4965 17.825 46.1282C17.825 44.7598 19.0432 42.2693 25.7911 40.6546C30.4197 39.6719 35.1443 39.2129 39.8756 39.2862Z",
    fill: "#E5E9F8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4377 39.8746C43.9824 39.8254 48.5184 40.2844 52.961 41.243C59.4352 42.803 60.6396 45.1566 60.6396 46.4976C60.6396 47.8386 59.4352 50.1922 52.961 51.7522C44.0314 53.5583 34.8304 53.5583 25.9008 51.7522C19.4266 50.1922 18.2358 47.8386 18.2358 46.4976C18.2358 45.1566 19.4266 42.803 25.9008 41.243C30.348 40.2837 34.8885 39.8247 39.4377 39.8746Z",
    fill: "#E3E7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9994 40.463C43.3669 40.4307 47.7241 40.8897 51.9889 41.8314C58.1756 43.3093 59.3528 45.5534 59.3528 46.8397C59.3528 48.126 58.1756 50.3838 51.9889 51.8617C43.4071 53.5984 34.5643 53.5984 25.9826 51.8617C19.7958 50.3838 18.6187 48.126 18.6187 46.8397C18.6187 45.5534 19.7958 43.3093 25.9826 41.8314C30.256 40.8862 34.6227 40.4271 38.9994 40.463Z",
    fill: "#E1E5F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5614 41.0378C42.742 40.9933 46.9147 41.4109 51.0034 42.283C56.9164 43.6514 58.0662 45.8408 58.0662 47.0723C58.0662 48.3039 56.9164 50.4385 51.0034 51.848C42.7919 53.5081 34.331 53.5081 26.1195 51.848C20.2065 50.4796 19.043 48.3039 19.043 47.0723C19.043 45.8408 20.2065 43.6924 26.1195 42.283C30.2083 41.4109 34.3809 40.9933 38.5614 41.0378Z",
    fill: "#DEE3F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1234 41.6262C42.1201 41.5806 46.1095 41.9798 50.0178 42.8167C55.6571 44.185 56.8616 46.1829 56.8616 47.3597C56.8616 48.5365 55.7255 50.5754 50.0178 51.9164C42.1659 53.4856 34.0809 53.4856 26.229 51.9164C20.5898 50.548 19.3853 48.5365 19.3853 47.3597C19.3853 46.1829 20.5213 44.144 26.229 42.8167C30.1373 41.9798 34.1267 41.5806 38.1234 41.6262Z",
    fill: "#DCE1F5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6853 42.2146C41.4974 42.1693 45.3028 42.5456 49.0322 43.3367C54.3977 44.6093 55.5063 46.525 55.5063 47.6608C55.5063 48.7965 54.3977 50.7122 49.0322 51.9712C41.5416 53.4674 33.829 53.4674 26.3384 51.9712C20.9729 50.7122 19.8643 48.7828 19.8643 47.6608C19.8643 46.5387 20.9729 44.6093 26.3384 43.3367C30.0679 42.5463 33.8732 42.17 37.6853 42.2146Z",
    fill: "#DADEF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2473 42.803C40.8753 42.7626 44.4968 43.1206 48.0467 43.8704C53.1384 45.0609 54.2334 46.8808 54.2334 47.9755C54.2334 49.0702 53.1384 50.8628 48.0467 52.0806C40.9156 53.4855 33.579 53.4855 26.4479 52.0806C21.3562 50.8765 20.2749 49.0565 20.2749 47.9755C20.2749 46.8945 21.3562 45.0882 26.4479 43.8704C29.9979 43.1213 33.6193 42.7634 37.2473 42.803Z",
    fill: "#D8DCF4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8096 43.3914C40.2576 43.3521 43.6996 43.687 47.0753 44.3903C51.8797 45.5124 52.9473 47.2228 52.9473 48.2354C52.9473 49.248 51.8797 50.9722 47.0753 52.0943C40.2965 53.428 33.3227 53.428 26.5439 52.0943C21.7396 50.9722 20.6719 49.2617 20.6719 48.2354C20.6719 47.2092 21.7396 45.4987 26.5439 44.3903C29.9195 43.6867 33.3616 43.3518 36.8096 43.3914Z",
    fill: "#D5DAF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3715 43.9798C39.6356 43.9386 42.8944 44.2552 46.0896 44.924C50.6201 45.9639 51.6604 47.5649 51.6604 48.5365C51.6604 49.508 50.6201 51.1091 46.0896 52.149C39.6766 53.408 33.08 53.408 26.667 52.149C22.1365 51.1091 21.0962 49.508 21.0962 48.5365C21.0962 47.5649 22.1365 45.9639 26.667 44.924C29.8576 44.2559 33.1119 43.9393 36.3715 43.9798Z",
    fill: "#D3D8F3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9471 44.5682C39.0218 44.5355 42.0913 44.8291 45.104 45.444C49.3608 46.4292 50.3873 47.9207 50.3873 48.8239C50.3873 49.727 49.3608 51.2322 45.104 52.2174C39.0507 53.385 32.8298 53.385 26.7765 52.2174C22.5197 51.2322 21.4932 49.7407 21.4932 48.8239C21.4932 47.907 22.5197 46.4155 26.7765 45.444C29.7939 44.8293 32.8679 44.5357 35.9471 44.5682Z",
    fill: "#D1D6F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5092 45.1566C38.3994 45.125 41.2848 45.3957 44.1187 45.964C48.1017 46.8808 49.101 48.2628 49.101 49.1249C49.101 49.987 48.1017 51.3691 44.1187 52.2722C38.4267 53.367 32.5781 53.367 26.8861 52.2722C22.903 51.3691 21.9038 49.987 21.9038 49.1249C21.9038 48.2628 22.903 46.8808 26.8861 45.964C29.7246 45.3957 32.6146 45.1251 35.5092 45.1566Z",
    fill: "#CED4F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.71
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0712 45.7313C37.7781 45.7014 40.4805 45.9583 43.1332 46.4976C46.8425 47.3187 47.828 48.6049 47.828 49.4123C47.828 50.2196 46.8425 51.5059 43.1332 52.3406C37.8008 53.344 32.3279 53.344 26.9956 52.3406C23.2862 51.5059 22.3145 50.2196 22.3145 49.4123C22.3145 48.6049 23.2862 47.3187 26.9956 46.4976C29.653 45.9587 32.3599 45.7019 35.0712 45.7313Z",
    fill: "#CCD2F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6333 46.3197C37.1601 46.2913 39.683 46.5252 42.1615 47.0176C45.5834 47.7839 46.5415 48.947 46.5415 49.7544C46.5415 50.5617 45.5834 51.6838 42.1615 52.4911C37.1858 53.4217 32.0808 53.4217 27.1051 52.4911C23.6832 51.7385 22.7251 50.5617 22.7251 49.7544C22.7251 48.947 23.6832 47.825 27.1051 47.0176C29.5836 46.5252 32.1065 46.2913 34.6333 46.3197Z",
    fill: "#CAD0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1953 46.9081C36.538 46.8847 38.877 47.1001 41.176 47.5513C44.3241 48.2355 45.2822 49.3028 45.2822 50.0007C45.2822 50.6985 44.3515 51.7659 41.176 52.4501C36.5617 53.3075 31.8289 53.3075 27.2147 52.4501C24.0665 51.7659 23.1084 50.7122 23.1084 50.0007C23.1084 49.2891 24.0392 48.2355 27.2147 47.5513C29.5136 47.1001 31.8526 46.8847 34.1953 46.9081Z",
    fill: "#C7CEF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7571 47.4965C35.9153 47.4741 38.0703 47.6666 40.1902 48.0712C43.0646 48.687 43.9817 49.6449 43.9817 50.3017C43.9817 50.9585 43.0646 51.9027 40.1902 52.5185C35.9358 53.2847 31.5785 53.2847 27.324 52.5185C24.4497 51.9027 23.5464 50.9448 23.5464 50.3017C23.5464 49.6586 24.4497 48.687 27.324 48.0712C29.4441 47.6673 31.599 47.4748 33.7571 47.4965Z",
    fill: "#C5CCEF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3193 48.0849C35.2936 48.0607 37.2655 48.2349 39.205 48.6049C41.8056 49.1386 42.6953 49.9733 42.6953 50.5891C42.6953 51.2048 41.8056 52.0396 39.205 52.5732C35.3119 53.2665 31.3268 53.2665 27.4337 52.5732C24.833 52.0396 23.9434 51.2048 23.9434 50.5891C23.9434 49.9733 24.833 49.1386 27.4337 48.6049C29.3733 48.2356 31.345 48.0614 33.3193 48.0849Z",
    fill: "#C3CAEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9223 48.6733C34.7165 48.657 36.5082 48.8082 38.2742 49.1249C40.5874 49.6038 41.4634 50.3428 41.4634 50.8764C41.4634 51.4101 40.5874 52.1627 38.2605 52.6416C34.7272 53.2437 31.1175 53.2437 27.5842 52.6416C25.271 52.1627 24.395 51.4238 24.395 50.8764C24.395 50.3291 25.271 49.6038 27.5842 49.1249C29.3456 48.8086 31.1328 48.6574 32.9223 48.6733Z",
    fill: "#C0C8EE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4435 49.2617C34.0538 49.2436 35.6623 49.3764 37.2478 49.6586C39.2873 50.0554 40.136 50.6849 40.136 51.1775C40.136 51.6701 39.2873 52.2996 37.2478 52.6964C34.0758 53.2239 30.8384 53.2239 27.6664 52.6964C25.6269 52.2996 24.7783 51.6701 24.7783 51.1775C24.7783 50.6849 25.6269 50.0554 27.6664 49.6586C29.2429 49.3778 30.8423 49.245 32.4435 49.2617Z",
    fill: "#BEC6ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.94
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.019 49.8365C33.4403 49.8199 34.8602 49.9298 36.2621 50.1648C38.0277 50.4933 38.849 51.0132 38.849 51.4511C38.849 51.889 38.0277 52.409 36.2621 52.7374C33.4471 53.1935 30.5771 53.1935 27.7621 52.7374C25.9965 52.409 25.1753 51.889 25.1753 51.4511C25.1753 51.0132 25.9965 50.4933 27.7621 50.1648C29.1686 49.9299 30.5931 49.82 32.019 49.8365Z",
    fill: "#BCC4EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.97
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5535 50.4248C32.7912 50.4172 34.0274 50.5134 35.2491 50.7122C36.741 50.9722 37.5486 51.3827 37.5486 51.7659C37.5486 52.149 36.741 52.5595 35.2491 52.8195C32.7943 53.1845 30.2989 53.1845 27.8441 52.8195C26.3522 52.5595 25.5583 52.149 25.5583 51.7659C25.5583 51.3827 26.3522 50.9722 27.8441 50.7122C29.0704 50.5134 30.3112 50.4173 31.5535 50.4248Z",
    fill: "#B9C2EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2896 52.0532C36.2896 52.6279 33.9901 53.0932 31.1431 53.0932C28.2961 53.0932 25.9829 52.6279 25.9829 52.0532C25.9829 51.4785 28.2961 51.0132 31.1431 51.0132C33.9901 51.0132 36.2896 51.4785 36.2896 52.0532Z",
    fill: "#B7C0EB"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.66 46.5654C55.2232 38.0046 55.2232 24.1247 46.66 15.5638C38.0968 7.00298 24.2132 7.00296 15.65 15.5638C7.08686 24.1247 7.08683 38.0046 15.65 46.5654C24.2132 55.1263 38.0968 55.1263 46.66 46.5654Z",
    fill: "url(#paint0_linear_165_3078)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1564 53.0932C43.2665 53.0932 53.0837 43.2786 53.0837 31.1717C53.0837 19.0649 43.2665 9.25029 31.1564 9.25029C19.0462 9.25029 9.229 19.0649 9.229 31.1717C9.229 43.2786 19.0462 53.0932 31.1564 53.0932Z",
    fill: "url(#paint1_linear_165_3078)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_3078",
    x1: 35080.7,
    y1: 12642.5,
    x2: 34378.5,
    y2: 11425.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F5F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_3078",
    x1: 31.1564,
    y1: 9.25029,
    x2: 31.1564,
    y2: 53.0932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE2FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls045);
export default __webpack_public_path__ + "static/media/ils_04_5.b4a8389dd7a0071e532b89a880b53872.svg";
export { ForwardRef as ReactComponent };